import { render, staticRenderFns } from "./AddGroup.vue?vue&type=template&id=7fd7a6c3&scoped=true&"
import script from "./AddGroup.vue?vue&type=script&lang=js&"
export * from "./AddGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd7a6c3",
  null
  
)

export default component.exports